import type { PhoneCountry } from "./types";

type PreferredCountrySeed = Omit<PhoneCountry, "format"> & { placeholder: string };

export const preferredCountries: PreferredCountrySeed[] = [
  { iso2: "ir", dialCode: "98", name: "Iran", localizedName: "ایران", placeholder: "___ ___ ____", priority: 1 },
  {
    iso2: "ae",
    dialCode: "971",
    name: "United Arab Emirates",
    localizedName: "الإمارات العربية المتحدة",
    placeholder: "__ ___ ____",
    priority: 2,
  },
  {
    iso2: "sa",
    dialCode: "966",
    name: "Saudi Arabia",
    localizedName: "المملكة العربية السعودية",
    placeholder: "__ ___ ____",
    priority: 3,
  },
  { iso2: "iq", dialCode: "964", name: "Iraq", localizedName: "العراق", placeholder: "___ ___ ____", priority: 4 },
  { iso2: "tr", dialCode: "90", name: "Turkey", localizedName: "Türkiye", placeholder: "___ ___ __ __", priority: 5 },
  { iso2: "qa", dialCode: "974", name: "Qatar", localizedName: "قطر", placeholder: "____ ____", priority: 6 },
  { iso2: "om", dialCode: "968", name: "Oman", localizedName: "عُمان", placeholder: "____ ____", priority: 7 },
  { iso2: "kw", dialCode: "965", name: "Kuwait", localizedName: "الكويت", placeholder: "____ ____", priority: 8 },
  { iso2: "bh", dialCode: "973", name: "Bahrain", localizedName: "البحرين", placeholder: "____ ____", priority: 9 },
  { iso2: "jo", dialCode: "962", name: "Jordan", localizedName: "الأردن", placeholder: "_ ____ ____", priority: 10 },
  { iso2: "lb", dialCode: "961", name: "Lebanon", localizedName: "لبنان", placeholder: "__ ___ ___", priority: 11 },
  { iso2: "eg", dialCode: "20", name: "Egypt", localizedName: "مصر", placeholder: "___ ___ ____", priority: 12 },
  {
    iso2: "de",
    dialCode: "49",
    name: "Germany",
    localizedName: "Deutschland",
    placeholder: "____ ________",
    priority: 13,
  },
  {
    iso2: "gb",
    dialCode: "44",
    name: "United Kingdom",
    localizedName: "United Kingdom",
    placeholder: "____ ______",
    priority: 14,
  },
  {
    iso2: "us",
    dialCode: "1",
    name: "United States",
    localizedName: "United States",
    placeholder: "(___) ___-____",
    priority: 15,
  },
  { iso2: "ca", dialCode: "1", name: "Canada", localizedName: "Canada", placeholder: "(___) ___-____", priority: 16 },
  { iso2: "fr", dialCode: "33", name: "France", localizedName: "France", placeholder: "_ __ __ __ __", priority: 17 },
  { iso2: "it", dialCode: "39", name: "Italy", localizedName: "Italia", placeholder: "___ _______", priority: 18 },
  { iso2: "es", dialCode: "34", name: "Spain", localizedName: "España", placeholder: "___ __ __ __", priority: 19 },
  {
    iso2: "nl",
    dialCode: "31",
    name: "Netherlands",
    localizedName: "Nederland",
    placeholder: "_ ________",
    priority: 20,
  },
  { iso2: "be", dialCode: "32", name: "Belgium", localizedName: "België", placeholder: "___ __ __ __", priority: 21 },
  {
    iso2: "ch",
    dialCode: "41",
    name: "Switzerland",
    localizedName: "Schweiz",
    placeholder: "__ ___ __ __",
    priority: 22,
  },
  { iso2: "at", dialCode: "43", name: "Austria", localizedName: "Österreich", placeholder: "___ ______", priority: 23 },
  { iso2: "se", dialCode: "46", name: "Sweden", localizedName: "Sverige", placeholder: "__ ___ __ __", priority: 24 },
  { iso2: "no", dialCode: "47", name: "Norway", localizedName: "Norge", placeholder: "___ __ ___", priority: 25 },
  { iso2: "dk", dialCode: "45", name: "Denmark", localizedName: "Danmark", placeholder: "__ __ __ __", priority: 26 },
  { iso2: "fi", dialCode: "358", name: "Finland", localizedName: "Suomi", placeholder: "__ ___ ____", priority: 27 },
  { iso2: "pl", dialCode: "48", name: "Poland", localizedName: "Polska", placeholder: "___ ___ ___", priority: 28 },
  { iso2: "ru", dialCode: "7", name: "Russia", localizedName: "Россия", placeholder: "(___) ___-__-__", priority: 29 },
  { iso2: "ua", dialCode: "380", name: "Ukraine", localizedName: "Україна", placeholder: "__ ___ __ __", priority: 30 },
  { iso2: "in", dialCode: "91", name: "India", localizedName: "भारत", placeholder: "_____ _____", priority: 31 },
  { iso2: "pk", dialCode: "92", name: "Pakistan", localizedName: "پاکستان", placeholder: "___ _______", priority: 32 },
  {
    iso2: "af",
    dialCode: "93",
    name: "Afghanistan",
    localizedName: "افغانستان",
    placeholder: "__ ___ ____",
    priority: 33,
  },
  {
    iso2: "az",
    dialCode: "994",
    name: "Azerbaijan",
    localizedName: "Azərbaycan",
    placeholder: "__ ___ __ __",
    priority: 34,
  },
  { iso2: "am", dialCode: "374", name: "Armenia", localizedName: "Հայաստան", placeholder: "__ ______", priority: 35 },
  {
    iso2: "ge",
    dialCode: "995",
    name: "Georgia",
    localizedName: "საქართველო",
    placeholder: "___ __ __ __",
    priority: 36,
  },
  {
    iso2: "kz",
    dialCode: "7",
    name: "Kazakhstan",
    localizedName: "Қазақстан",
    placeholder: "(___) ___-__-__",
    priority: 37,
  },
  {
    iso2: "uz",
    dialCode: "998",
    name: "Uzbekistan",
    localizedName: "Oʻzbekiston",
    placeholder: "__ ___ __ __",
    priority: 38,
  },
  {
    iso2: "my",
    dialCode: "60",
    name: "Malaysia",
    localizedName: "Malaysia",
    placeholder: "__-____ ____",
    priority: 39,
  },
  {
    iso2: "id",
    dialCode: "62",
    name: "Indonesia",
    localizedName: "Indonesia",
    placeholder: "___-____-____",
    priority: 40,
  },
  { iso2: "sg", dialCode: "65", name: "Singapore", localizedName: "Singapore", placeholder: "____ ____", priority: 41 },
  {
    iso2: "th",
    dialCode: "66",
    name: "Thailand",
    localizedName: "ประเทศไทย",
    placeholder: "__ ___ ____",
    priority: 42,
  },
  { iso2: "vn", dialCode: "84", name: "Vietnam", localizedName: "Việt Nam", placeholder: "___ ___ ____", priority: 43 },
  {
    iso2: "kr",
    dialCode: "82",
    name: "South Korea",
    localizedName: "대한민국",
    placeholder: "__-____-____",
    priority: 44,
  },
  { iso2: "jp", dialCode: "81", name: "Japan", localizedName: "日本", placeholder: "__-____-____", priority: 45 },
  {
    iso2: "au",
    dialCode: "61",
    name: "Australia",
    localizedName: "Australia",
    placeholder: "___ ___ ___",
    priority: 46,
  },
  {
    iso2: "nz",
    dialCode: "64",
    name: "New Zealand",
    localizedName: "Aotearoa",
    placeholder: "__ ___ ____",
    priority: 47,
  },
  { iso2: "br", dialCode: "55", name: "Brazil", localizedName: "Brasil", placeholder: "(__) _____-____", priority: 48 },
  { iso2: "mx", dialCode: "52", name: "Mexico", localizedName: "México", placeholder: "(___) ___ ____", priority: 49 },
  {
    iso2: "za",
    dialCode: "27",
    name: "South Africa",
    localizedName: "South Africa",
    placeholder: "__ ___ ____",
    priority: 50,
  },
];

export const PHONE_COUNTRIES: PhoneCountry[] = preferredCountries
  .map(({ placeholder, ...country }) => ({ ...country, format: placeholder, placeholder }))
  .sort((a, b) => (a.priority || Number.MAX_SAFE_INTEGER) - (b.priority || Number.MAX_SAFE_INTEGER));

export const countryFlagUrl = (iso2: string) => `/Flag/${iso2.toUpperCase()}.svg`;
